import { vacancyQueryKeys } from "./queryKeys";

import { useEntityHistory } from "@/lib/hooks/useEntityHistory";

interface UseVacancyHistoryParams {
  vacancyId: string;
  from: Date;
  to?: Date;
  pageSize?: number;
}

export function useVacancyHistory({
  vacancyId,
  from,
  to,
  pageSize = 30,
}: UseVacancyHistoryParams) {
  return useEntityHistory({
    queryKey: vacancyQueryKeys.history(vacancyId, from, to, pageSize),
    apiPath: `/api/v2/Vacancies/${vacancyId}/history`,
    from,
    to,
    pageSize,
    enabled: !!vacancyId,
  });
}
